import { render, staticRenderFns } from "./Desgin.vue?vue&type=template&id=3e2bbcdc&scoped=true"
import script from "./Desgin.vue?vue&type=script&lang=js"
export * from "./Desgin.vue?vue&type=script&lang=js"
import style0 from "./Desgin.vue?vue&type=style&index=0&id=3e2bbcdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2bbcdc",
  null
  
)

export default component.exports